<template>
	<div v-if="show" :class="{ 'loading' : !is_loaded}" class="loadable">
		<!--<button class="button" @click="refresh">refresh</button>-->
		<label class="text-uppercase" @click="iniChart">Completion with time remaining</label>
		<GChart
			type="ColumnChart"
			:data="chartData"
			:options="chartOptions"
			:events="chartEvents"
			ref="chart"
			@ready="onChartReady"
		/>
	</div>

</template>

<script>
	export default{
		props: ['course'],
		data : function(){
			return {
				show : false,
				chartData : [],
				chartOptions : {
					isStacked: true,
					height: 250,
					chartArea:{width:'100%'},
					legend: {position: 'bottom', textStyle: {fontSize: 9}},
					colors: ['#ccc','#db504a','#ffd166' ,'#00777b', '#00FF00' ]
				},
				chartEvents : {},
				chart :null,
				responsive : false,
				colors : null,
				is_loaded : false
			}
		},

		created : function(){

			this.colors = this.config.COLORS;

			this.chartOptions.colors = [
				this.colors.RED,
				this.colors.ORANGE,
				this.colors.YELLOW,
				this.colors.LIGHT_GREEN,
				this.colors.GREEN
			];

			var vue_instance = this;
			this.chartEvents = {
				select : () => {
					var selection = this.chart.getSelection();

					var row, column = null;

					if(selection.length == 0){
						vue_instance.emitSelection('none', {
							row : null, 
							column : null
						});
					}else{
						vue_instance.emitSelection('filter-months-to-go', {
							row : selection[0].row+1,
							column : selection[0].column
						});
					}
				}
			}

			this.iniChart();
		},
		methods : {
			iniChart : function(){
				var params = {
					filters : {},
					id : this.course
				}
				this.$store.dispatch('getMonthsToGo', params).then((res) => {

					this.chartData = res.data.data;

					this.show = true;
				}).catch((error) => {
					console.log(error);
				});
			},
			refresh : function(){
				this.iniChart();
			},
			onChartReady : function(chart, google){
				this.chart = chart;

				this.is_loaded = true;
			},
			emitSelection : function (type, data){
				this.$emit('filter', {
					type : type,
					row : data.row,
					column : data.column
				});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/charts/ProgramScheduleChartComponent.vue